/* Carbon Madras — CRO behaviours: announcement rotator, size chart modal, sticky buy bar. */
(function () {
  if (window.__CM_CRO_INIT__) return;
  window.__CM_CRO_INIT__ = true;

  var booted = false;
  function boot() {
    if (booted) return;
    booted = true;
    initAnnouncement();
    initSizeChart();
    initStickyBar();
    hideNavItems();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Theme editor re-renders sections; re-run the parts that are cheap to re-bind.
  document.addEventListener('shopify:section:load', function () {
    initAnnouncement();
    initSizeChart();
    initStickyBar();
    hideNavItems();
  });

  /* ---------------- Hide empty nav categories ----------------
     Theme-side only; the live Shopify navigation menu is not modified.
     Fallback for browsers without :has() support. Edit this list to change it. */
  var CM_HIDDEN_NAV = ['/collections/sale-999', '/collections/nobrac'];
  function hideNavItems() {
    if (!CM_HIDDEN_NAV.length) return;
    document.querySelectorAll('.mega-menu__list > li > a, .menu-drawer__submenu a').forEach(function (a) {
      var href = (a.getAttribute('href') || '').split('?')[0].replace(/\/$/, '');
      for (var i = 0; i < CM_HIDDEN_NAV.length; i++) {
        if (href === CM_HIDDEN_NAV[i]) {
          var li = a.closest('li');
          if (li) li.classList.add('cm-nav-hidden');
          return;
        }
      }
    });
  }

  /* ---------------- Announcement rotator ---------------- */
  function initAnnouncement() {
    document.querySelectorAll('.cm-announcement__viewport').forEach(function (vp) {
      if (vp.dataset.cmBound === '1') return;
      vp.dataset.cmBound = '1';
      var slides = vp.querySelectorAll('.cm-announcement__slide');
      if (slides.length < 2) return;
      var speed = parseInt(vp.dataset.speed, 10) || 4;
      var i = 0;
      setInterval(function () {
        // Fade the current message right out, then bring the next one in.
        // A straight cross-fade leaves two lines of text stacked mid-transition.
        slides[i].classList.remove('is-active');
        var next = (i + 1) % slides.length;
        setTimeout(function () {
          slides[next].classList.add('is-active');
          i = next;
        }, 300);
      }, speed * 1000);
    });
  }

  /* ---------------- Size chart ---------------- */
  function initSizeChart() {
    var trigger = document.querySelector('.cm-sizechart-trigger');
    var modal = document.getElementById('cm-size-chart-modal');
    if (!trigger || !modal) return;

    // Lift the modal out to <body> so page stacking/overflow contexts can't clip it.
    if (modal.parentNode !== document.body) document.body.appendChild(modal);

    // Move the trigger up beside the size option's legend so it sits next to the chips.
    if (trigger.dataset.cmMoved !== '1') {
      var legends = document.querySelectorAll('.product__info-container legend.form__label, .product__info-container .form__label');
      for (var i = 0; i < legends.length; i++) {
        var txt = (legends[i].textContent || '').toLowerCase();
        if (txt.indexOf('size') !== -1) {
          var row = document.createElement('div');
          row.className = 'cm-legend-row';
          legends[i].parentNode.insertBefore(row, legends[i]);
          row.appendChild(legends[i]);
          row.appendChild(trigger);
          trigger.dataset.cmMoved = '1';
          break;
        }
      }
    }

    if (trigger.dataset.cmBound === '1') return;
    trigger.dataset.cmBound = '1';

    function open() {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      var closeBtn = modal.querySelector('.cm-modal__close');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      modal.hidden = true;
      document.body.style.overflow = '';
      trigger.focus();
    }
    trigger.addEventListener('click', function (e) { e.preventDefault(); open(); });
    modal.addEventListener('click', function (e) {
      if (e.target.closest('.cm-modal__close') || e.target.classList.contains('cm-modal__overlay')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }

  /* ---------------- Sticky buy bar ---------------- */
  function initStickyBar() {
    var bar = document.getElementById('cm-sticky-bar');
    if (!bar || bar.dataset.cmBound === '1') return;

    var infoContainer = document.querySelector('.product__info-container');
    var mainForm = document.querySelector('.product__info-container form[data-type="add-to-cart-form"]');
    if (!infoContainer || !mainForm) return;
    bar.dataset.cmBound = '1';

    var anchor = mainForm.closest('product-form') || mainForm;
    var addBtn = bar.querySelector('[data-cm-add]');
    var buyBtn = bar.querySelector('[data-cm-buy]');
    var priceSlot = bar.querySelector('.cm-stickybar__price');

    /* --- mirror price + availability from the live buy box --- */
    function sync() {
      var srcPrice = infoContainer.querySelector('.price');
      if (srcPrice && priceSlot) priceSlot.innerHTML = srcPrice.outerHTML;

      var srcBtn = mainForm.querySelector('button[name="add"]');
      var soldOut = !srcBtn || srcBtn.hasAttribute('disabled');
      [addBtn, buyBtn].forEach(function (b) {
        if (!b) return;
        if (soldOut) { b.setAttribute('disabled', 'disabled'); }
        else { b.removeAttribute('disabled'); }
      });
      if (soldOut && addBtn) {
        addBtn.querySelector('span').textContent = addBtn.dataset.soldOutText || 'Sold out';
      } else if (addBtn) {
        addBtn.querySelector('span').textContent = addBtn.dataset.addText || 'Add to cart';
      }
    }
    sync();

    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(sync, 150);
    }).observe(infoContainer, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'value'] });

    /* --- show/hide once the buy box leaves the viewport --- */
    function setVisible(v) {
      bar.classList.toggle('is-visible', v);
      document.body.classList.toggle('cm-stickybar-open', v);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          // Show only once the buy box has scrolled ABOVE the viewport.
          setVisible(!e.isIntersecting && e.boundingClientRect.top < 0);
        });
      }, { threshold: 0, rootMargin: '0px 0px -20% 0px' }).observe(anchor);
    } else {
      window.addEventListener('scroll', function () {
        var r = anchor.getBoundingClientRect();
        setVisible(r.bottom < 0);
      }, { passive: true });
    }

    /* --- actions --- */
    function currentVariantId() {
      var input = mainForm.querySelector('input[name="id"]');
      return input ? input.value : null;
    }
    function currentQty() {
      var q = document.querySelector('.product__info-container input[name="quantity"]');
      var n = q ? parseInt(q.value, 10) : 1;
      return n > 0 ? n : 1;
    }

    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var srcBtn = mainForm.querySelector('button[name="add"]');
        if (srcBtn && !srcBtn.hasAttribute('disabled')) srcBtn.click();
      });
    }

    if (buyBtn) {
      buyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = currentVariantId();
        if (!id) return;
        buyBtn.setAttribute('disabled', 'disabled');
        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: currentQty() }] })
        })
          .then(function (r) { return r.json(); })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () {
            buyBtn.removeAttribute('disabled');
            var srcBtn = mainForm.querySelector('button[name="add"]');
            if (srcBtn) srcBtn.click();
          });
      });
    }
  }
})();
